const DEV_URL = 'https://7kfgi36eo8.execute-api.ap-northeast-1.amazonaws.com/default/'
const ST_URL = 'https://gmm4yruxv5.execute-api.ap-northeast-1.amazonaws.com/default/'
const PRD_URL = 'https://dju42tp1u3.execute-api.ap-northeast-1.amazonaws.com/v1/'

const DEV_AWS_USER_POOLS_ID = 'ap-northeast-1_AgekSaVWt'
const ST_AWS_USER_POOLS_ID = 'ap-northeast-1_dGRckDhQ3'
const PRD_AWS_USER_POOLS_ID = 'ap-northeast-1_bwFvWPddH'
const URI_GET_OPT_IN = 'get-opt-in'
const URI_CHANGE_OPT_IN = 'change-opt-in'

function api_url(aws_user_pools_id) {
    if(aws_user_pools_id == PRD_AWS_USER_POOLS_ID) {
        return PRD_URL
    } else if(aws_user_pools_id == ST_AWS_USER_POOLS_ID) {
        return ST_URL
    } else if(aws_user_pools_id == DEV_AWS_USER_POOLS_ID) {
        return DEV_URL
    }
    return DEV_URL
}
function get_opt_in_api_url(aws_user_pools_id) {
    return api_url(aws_user_pools_id) + URI_GET_OPT_IN
}
function change_opt_in_api_url(aws_user_pools_id) {
    return api_url(aws_user_pools_id) + URI_CHANGE_OPT_IN
}
export default {
    get_opt_in_api_url,
    change_opt_in_api_url,
};